import { environment } from "@/lib/constants";
import { useQuery } from "@tanstack/react-query";

// {"symbol":"AAVE","date":"","price":270.68,"cfgi":59,"data_price":63.5,"data_volatility":75,"data_volume":75.5,"data_impulse":70,"data_technical":80,"data_social":11,"data_dominance":54.5,"data_trends":1,"datas_whales":2,"data_orders":2.5}
export interface CFGI {
  symbol: string;
  price: number;
  cfgi: number;
  data_price: number;
  data_volatility: number;
  data_volume: number;
  data_impulse: number;
  data_technical: number;
  data_social: number;
  data_dominance: number;
  data_trends: number;
  datas_whales: number;
  data_orders: number;
}

async function fetchCFGI(): Promise<CFGI[]> {
  const response = await fetch(environment.cfgiURL);
  if (!response.ok) {
    throw new Error("Failed to fetch CFGI data");
  }
  return response.json();
}

export function useCFGI() {
  return useQuery({
    queryKey: ["cfgi"],
    queryFn: fetchCFGI,
    refetchInterval: 5000, // Refetch every 5 seconds
    refetchIntervalInBackground: true,
    staleTime: 0, // Consider data stale immediately so we always refetch after interval
  });
}
